import { Page } from "@/components/Page";
import { Article } from "@/components/Article";
import { LocationPage } from "@/components/LocationPage";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CardsGrid } from "@/components/CardsGrid";
import Logo from "@/components/Logo";
import CardArticle from "@/components/CardArticle";
import CardFull from "@/components/CardFull";
import HeroFramed from "@/components/HeroFramed";
import HeroWide from "@/components/HeroWide";
import HeroCarousel from "@/components/HeroCarousel";
import Accordion from "@/components/Accordion";
import HeroArticle from "@/components/HeroArticle";
import { ContactSection } from "@/components/sections/ContactSection";
import { FilterSection } from "@/components/sections/FilterSection";
import { CardGridWithFilters } from "@/components/sections/CardGridWithFilters";
import { CalculatorSection } from "@/components/sections/CalculatorSection";
import { FaqSection } from "@/components/sections/FaqSection";
import { LinedListSection } from "@/components/sections/LinedListSection";
import { MatchScheduleSection } from "@/components/sections/MatchScheduleSection";
import StepDisplay from "@/components/StepDisplay";
import Carousel from "@/components/Carousel";
import TextHeader from "@/components/TextHeader";
import ArticleHighlight from "@/components/ArticleHighlight";
import ArticleSection from "@/components/ArticleSection";
import VideoPlayerButton from "@/components/VideoPlayerButton";
import InfoBlock from "@/components/InfoBlock";
import LocationSearch from "@/components/LocationSearch";
import LocationCard from "@/components/LocationCard";
import EmbeddedForm from "@/components/EmbeddedForm";
import { EmbeddedHTML } from "@/components/EmbeddedHTML";
import { RedirectsConfig } from "@/components/redirects";
import { AiImagesConfig } from "@/components/aiImages";
import { NotificationBanner } from "@/components/NotificationBanner";

export const COMPONENTS = {
  page: Page,
  article: Article,
  locationPage: LocationPage,
  header: Header,
  footer: Footer,
  cardsGrid: CardsGrid,
  cardGridWithFilters: CardGridWithFilters,
  logo: Logo,
  cardLogo: Logo,
  cardArticle: CardArticle,
  cardFull: CardFull,
  heroFramed: HeroFramed,
  heroArticle: HeroArticle,
  heroWide: HeroWide,
  heroCarousel: HeroCarousel,
  accordion: Accordion,
  stepDisplay: StepDisplay,
  carousel: Carousel,
  textHeader: TextHeader,
  articleHighlight: ArticleHighlight,
  articleSection: ArticleSection,
  contactSection: ContactSection,
  filterSection: FilterSection,
  calculatorSection: CalculatorSection,
  faqSection: FaqSection,
  linedListSection: LinedListSection,
  matchScheduleSection: MatchScheduleSection,
  videoPlayerButton: VideoPlayerButton,
  infoBlock: InfoBlock,
  locationSearch: LocationSearch,
  locationCard: LocationCard,
  embeddedForm: EmbeddedForm,
  embeddedHTML: EmbeddedHTML,
  redirectsConfig: RedirectsConfig,
  aiImagesConfig: AiImagesConfig,
  notificationBanner: NotificationBanner,
};
